import { render } from "./AdminloginComponent.vue?vue&type=template&id=468766d5&scoped=true"
import script from "./AdminloginComponent.vue?vue&type=script&lang=js"
export * from "./AdminloginComponent.vue?vue&type=script&lang=js"

import "./AdminloginComponent.vue?vue&type=style&index=0&id=468766d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468766d5"]])

export default __exports__